/**
 * Brand mark — the MRN monogram from the client's master logo.
 *
 * Vector-extracted from the supplied artwork (Client Provided/logo Mah.ai)
 * to /brand/mrn-monogram.svg — just the MRN ligature, with the red ring and
 * "Mah Rokh Naz" subtitle dropped (those live in the full footer lockup).
 *
 * The SVG is applied as a CSS mask so its silhouette punches through a
 * `bg-current` layer, which makes the mark recolor automatically via the
 * parent's text color: cream on dark, charcoal on cream. Same trick
 * `SocialIconLink` uses for the footer icons.
 *
 * Sizing: the ligature renders at `1em` tall, so it scales with the
 * parent's font-size. viewBox is 531.43 × 210.04 → width = height × 2.530.
 */
export default function Wordmark({ className = '', light = false }: { className?: string; light?: boolean }) {
  return (
    <span
      className={`inline-flex items-end ${light ? 'text-surface' : 'text-ink'} ${className}`}
      style={{ direction: 'ltr' }}
      aria-label="Mah Rokh Naz"
    >
      <span
        aria-hidden
        className="block bg-current"
        style={{
          height: '1em',
          width: 'calc(1em * 531.43 / 210.04)',
          maskImage: 'url(/brand/mrn-monogram.svg)',
          WebkitMaskImage: 'url(/brand/mrn-monogram.svg)',
          maskSize: 'contain',
          WebkitMaskSize: 'contain',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat',
        }}
      />
    </span>
  )
}
